import { WorkflowTemplateIcon } from './WorkflowTemplateIconGroup';

export type WorkflowActionFeature = {
  name?: string;
  orderIndex?: string;
  iconUrl?: string;
  iconActionType?: string;
  actionTypeId?: string;
};

export function getWorkflowIconsFromFeatures(
  features: WorkflowActionFeature[] = []
): WorkflowTemplateIcon[] {
  return features
    .slice()
    .sort((a, b) => Number(a.orderIndex ?? 0) - Number(b.orderIndex ?? 0))
    .flatMap((feature): WorkflowTemplateIcon[] => {
      const { iconUrl, iconActionType, actionTypeId, name } = feature;

      if (iconUrl) {
        return [
          {
            actionType: actionTypeId ?? name ?? '',
            iconUrl,
            label: name,
          },
        ];
      }

      if (iconActionType) {
        return [{ actionType: iconActionType }];
      }

      return [];
    });
}
